<!-- Desktop HTML -->
<div *ngIf='screenWidth > 1230'>
  <!-- <div class="visible-lg" (window:orientationchange)="screenRotate($event)"> -->

  <div (window:orientationchange)="screenRotate($event)">
    <div class="flex-container">
      <div class="bmw-lg-sib-sidebar flex-12-5">
        <div style="font-weight:bold">Filter by</div>
        <div style="margin-top:15px">Main Group</div>
        <div>
          <select class="form-control" id="group" [(ngModel)]='inputMainGroup'>
            <option [ngValue]="undefined" disabled selected> Select Main Group </option>
            <option *ngFor="let group of mainGroupList" [ngValue]="group">{{group}}</option>
          </select>
        </div>
        <div style="margin-top:25px">Year Published</div>
        <div class="flex-container row">
          <div class="flex-28" style="padding-top:10px">From</div>
          <div class="flex" style="width:100%">
            <select class="form-control" id="fromYear" [(ngModel)]='inputFromYear'>
              <option *ngFor="let year of fromYears" [ngValue]="year">{{year}}</option>
            </select>
          </div>
        </div>
        <div class="flex-container row">
          <div class="flex-28" style="padding-top:10px">To</div>
          <div class="flex" style="width:100%">
            <select class="form-control" id="toYear" [(ngModel)]='inputToYear'>
              <option *ngFor="let year of toYears" [ngValue]="year">{{year}}</option>
            </select>
          </div>
        </div>
        <button [disabled]='noContent' [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="pointer bmw-button-primary lg-primary"
          (click)='applyFilter()'>Apply Filter</button>
        <div class="pointer bmw-button-secondary lg-secondary" (click)='clearFilter()'>Cancel Filter</div>
        <a [routerLink]='["/manage-profile", "bulletin-manager"]'>
          <div class="bmw-lg-sib-bulletin-manager-label" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>Saved Bulletin Manager</div>
        </a>
      </div>
      <div class="flex">
        <div class="flex-container row">
          <div class="flex-8"></div>
          <div class="flex-81-3">
            <div>
              <div class="flex-30"></div>
              <div class="flex-container row flex-align-center">
                <div [ngClass]='{"bmw-active-link": isShowAll && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"),
                "mini-active-link": isShowAll && APP_SETTINGS.isMINI === "true",
               "rr-active-link": isShowAll && APP_SETTINGS.isRollsRoyce === "true"}'
                  class="pointer" style="padding-bottom: 20px" (click)='showAll()'>ALL</div>
                <div [ngClass]='{"bmw-active-link": isShowNew && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"),
                "mini-active-link": isShowNew && APP_SETTINGS.isMINI === "true",
                "rr-active-link": isShowNew && APP_SETTINGS.isRollsRoyce === "true"}'
                  class="pointer" style="padding-bottom: 20px" (click)='showNew();'>
                  NEW
                  <div class="badge" *ngIf="newDocsCount>0" [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>{{newDocsCount}}</div>
                </div>
                <div [ngClass]='{"bmw-active-link": isShowHistory && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true")
                , "mini-active-link": isShowHistory && APP_SETTINGS.isMINI === "true",
                "rr-active-link": isShowHistory && APP_SETTINGS.isRollsRoyce === "true"}'
                  class="pointer" style="padding-bottom: 20px" (click)='showHistory()'>HISTORY</div>
                <div [ngClass]='{"bmw-active-link": isShowSaved && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"),
                "mini-active-link": isShowSaved && APP_SETTINGS.isMINI === "true",
                "rr-active-link": isShowSaved && APP_SETTINGS.isRollsRoyce === "true"}'
                  class="pointer" style="padding-bottom: 20px" (click)='showSaved()'>SAVED</div>
              </div>
              <div class="flex-30"></div>
            </div>
            <div class="bmw-lg-sib-content">
              <div class="flex-container" style="padding:27px 20px 34px 30px">
                <div class="bmw-lg-sib-title flex">Parts Bulletins</div>
                <div class="flex"></div>
                <div class="flex-32">
                  <form class="input-group" name="findDocs" style="width: 100%">
                    <input type="text" class="form-control" size=15 style="height:34px;font-size:16px;border-radius:0px" placeholder="Find Bulletin"
                      name="techDoc" [(ngModel)]="search4bulletins">
                    <div class="input-group-btn">
                      <button [ngClass]="{'mini-button-style' : APP_SETTINGS.isMINI === 'true', 'bmw-button-style': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true'),
                      'rr-button-style' : APP_SETTINGS.isRollsRoyce === 'true'}" class="btn btn-default"
                        type="submit">
                        <i class="glyphicon glyphicon-search"></i>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
              <div *ngIf='isShowSaved'>
                <div class="alert alert-warning" role="alert" *ngIf='errorMessage?.length > 0'>{{errorMessage}}</div>
                <div *ngIf='partsBulletins?.length > 0'>
                  <div *ngFor='let doc of partsBulletins; let i=index'>
                    <a class="flex-container row" (click)='expandPbs[i] = !expandPbs[i]' [ngClass]='{"active": expandPbs[i]}' [href]='"#pbs" + i'
                      style="margin:0 30px" data-toggle="collapse">
                      <div class="flex-5">
                        <i class="material-icons">folder_special</i>
                      </div>
                      <div class="flex-90" style="font-weight: bold;line-height:1.8">
                        {{doc?.title}}
                      </div>
                      <div class="flex" style="text-align: right">
                        <i class="material-icons bmw-pbs-toggle-expand" [ngClass]='{"active": expandPbs[i]}'>expand_more</i>
                      </div>
                    </a>
                    <div [id]='"pbs" + i' class="collapse bmw-lg-save">
                      <div class="flex-container row" *ngFor='let bulletin of doc?.content' style="margin-left:4%">
                        <div class="flex-5" style="text-align:center">
                          <div *ngIf='bulletin?.savedBulletinGroup; else elseBlock'>
                            <i class="material-icons">star</i>
                          </div>
                          <ng-template #elseBlock>
                            <ng-container *ngIf='bulletin?.updatedBulletin; else elseBlock2'>
                              <i class="material-icons">new_releases</i>
                            </ng-container>
                          </ng-template>
                          <ng-template #elseBlock2>
                            <ng-container *ngIf='bulletin?.newBulletin'>
                              <i class="material-icons">fiber_new</i>
                            </ng-container>
                          </ng-template>
                        </div>
                        <div class="flex-12">{{bulletin?.bulletinDisplayNumber}}</div>
                        <div class="flex-70">{{bulletin.description}}</div>
                        <div class="flex">{{bulletin.releaseDate | date: 'yyyy-MM-dd'}}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf='!isShowSaved'>
                <div class="flex-container row" style="border-bottom:2px solid #e9e9e9;">
                  <div class="flex-5"></div>
                  <div style="display:inherit" class="flex-8">
                    <div style="font-weight:bold;font-size:12px;">Bulletin#</div>
                    <i class="fa pointer" (click)="sortByProperty('bulletinDisplayId')" style="margin-left:5px" [ngClass]="{'fa-sort': column != 'bulletinDisplayId', 'fa-sort-asc bmw-sort-control-asc': (column == 'bulletinDisplayId' && isDesc), 'fa-sort-desc': (column == 'bulletinDisplayId' && !isDesc) }"
                      aria-hidden="true"> </i>
                  </div>
                  <div class="flex-4"></div>
                  <div style="display:inherit" class="flex">
                    <div style="font-weight:bold;font-size:12px;">Title</div>
                    <i class="fa pointer" (click)="sortByProperty('description')" style="margin-left:5px" [ngClass]="{'fa-sort': column != 'description', 'fa-sort-asc bmw-sort-control-asc': (column == 'description' && isDesc), 'fa-sort-desc': (column == 'description' && !isDesc) }"
                      aria-hidden="true"> </i>
                  </div>
                  <div class="flex-7"></div>
                  <div style="display:inherit" class="flex-17">
                    <div style="font-weight:bold;font-size:12px;">Date</div>
                    <i class="fa pointer" (click)="sortByProperty('releaseDate')" style="margin-left:5px" [ngClass]="{'fa-sort': column != 'releaseDate', 'fa-sort-asc bmw-sort-control-asc': (column == 'releaseDate' && isDesc), 'fa-sort-desc': (column == 'releaseDate' && !isDesc) }"
                      aria-hidden="true"> </i>
                  </div>
                </div>
                <div class="alert alert-warning" role="alert" *ngIf='errorMessage?.length > 0'>{{errorMessage}}</div>
                <div *ngIf='partsBulletins?.length > 0 && isShowHistory'>
                  <a target='_blank' [href]='"mount/parts_bulletin/"+doc?.bulletinFile?.fileName' *ngFor='let doc of partsBulletins | filterResults : filter |
                        searchFilter: "bulletinDisplayId,bulletinDisplayNumber,description, releaseDate": search4bulletins | sortBy: {property: column, direction: direction} | paginate: { itemsPerPage: 10, currentPage: p }'
                    class="bmw-lg-sib flex-container row" (click)='addBulletinToHistory(isShowHistory, doc?.id, doc?.bulletinDisplayNumber)'>

                    <div class="flex-5" style="text-align:center">
                      <div *ngIf='doc?.savedBulletinGroup; else elseBlock'>
                        <i class="material-icons">star</i>
                      </div>
                      <ng-template #elseBlock>
                        <ng-container *ngIf='doc?.updatedBulletin; else elseBlock2'>
                          <i class="material-icons">new_releases</i>
                        </ng-container>
                      </ng-template>
                      <ng-template #elseBlock2>
                        <ng-container *ngIf='doc?.newBulletin'>
                          <i class="material-icons">fiber_new</i>
                        </ng-container>
                      </ng-template>
                    </div>
                    <div class="flex-8">{{doc?.bulletinDisplayNumber}}</div>
                    <div class="flex-4"></div>
                    <div class="flex">{{doc?.description}}</div>
                    <div class="flex-7"></div>
                    <div class="flex-17">{{doc?.releaseDate | date: 'yyyy-MM-dd'}}</div>
                  </a>
                </div>
                <div *ngIf='partsBulletins?.length > 0 && (isShowNew || isShowAll)'>
                  <div *ngFor='let doc of partsBulletins | filterResults : filter |
                  searchFilter: "bulletinDisplayId,bulletinDisplayNumber,description,releaseDate": search4bulletins | sortBy: {property: column, direction: direction} | paginate: { itemsPerPage: 10, currentPage: p }'>
                    <div *ngIf='doc?.attachments?.length > 0'>
                      <a target='_blank' [href]='"mount/parts_bulletin/"+doc?.attachments[0]?.fileName' class="bmw-lg-sib flex-container row" (click)='addBulletinToHistory(isShowHistory, doc?.id, doc?.bulletinDisplayNumber)'>

                        <div class="flex-5" style="text-align:center">
                          <div *ngIf='doc?.savedBulletinGroup; else elseBlock'>
                            <i class="material-icons">star</i>
                          </div>
                          <ng-template #elseBlock>
                            <ng-container *ngIf='doc?.updatedBulletin; else elseBlock2'>
                              <i class="material-icons">new_releases</i>
                            </ng-container>
                          </ng-template>
                          <ng-template #elseBlock2>
                            <ng-container *ngIf='doc?.newBulletin'>
                              <i class="material-icons">fiber_new</i>
                            </ng-container>
                          </ng-template>
                        </div>
                        <div class="flex-8">{{doc?.bulletinDisplayNumber}}</div>
                        <div class="flex-4"></div>
                        <div class="flex">{{doc?.description}}</div>
                        <div class="flex-7"></div>
                        <div class="flex-17">{{doc?.releaseDate | date: 'yyyy-MM-dd'}}</div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <pagination-controls (pageChange)="p = $event;pageNumChange($event)"></pagination-controls>
          </div>
          <div class="flex"></div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Ipad Pro HTML -->
<div *ngIf='screenWidth >= 991 && screenWidth <= 1230'>
  <!-- <div class="visible-md" (window:orientationchange)="screenRotate($event)"> -->

  <div (window:orientationchange)="screenRotate($event)">
    <div class="flex-container">
      <div class="bmw-lg-sib-sidebar flex-15-5">
        <div style="font-weight:bold">Filter by</div>
        <div style="margin-top:15px">Main Group</div>
        <div>
          <select class="form-control" id="group" [(ngModel)]='inputMainGroup'>
            <option [ngValue]="undefined" disabled selected> Select Main Group </option>
            <option *ngFor="let group of mainGroupList" [ngValue]="group">{{group}}</option>
          </select>
        </div>
        <div style="margin-top:25px">Year Published</div>
        <div class="flex-container row">
          <div class="flex-28" style="padding-top:10px">From</div>
          <div class="flex" style="width:100%">
            <select class="form-control" id="fromYear" [(ngModel)]='inputFromYear'>
              <option *ngFor="let year of fromYears" [ngValue]="year">{{year}}</option>
            </select>
          </div>
        </div>
        <div class="flex-container row">
          <div class="flex-28" style="padding-top:10px">To</div>
          <div class="flex" style="width:100%">
            <select class="form-control" id="toYear" [(ngModel)]='inputToYear'>
              <option *ngFor="let year of toYears" [ngValue]="year">{{year}}</option>
            </select>
          </div>
        </div>
        <div [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="pointer bmw-button-primary lg-primary"
          (click)='applyFilter()'>Apply Filter</div>
        <div class="pointer bmw-button-secondary lg-secondary" (click)='clearFilter()'>Cancel Filter</div>
        <a [routerLink]='["/manage-profile", "bulletin-manager"]'>
          <div class="bmw-lg-sib-bulletin-manager-label" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>Saved Bulletin Manager</div>
        </a>
      </div>
      <div class="flex">
        <div class="flex-container row">
          <div class="flex-8"></div>
          <div class="flex-81-3">
            <div>
              <div class="flex-30"></div>
              <div class="flex-container row flex-align-center">
                <div [ngClass]='{"bmw-active-link": isShowAll && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"),
                "mini-active-link": isShowAll && APP_SETTINGS.isMINI === "true",
               "rr-active-link": isShowAll && APP_SETTINGS.isRollsRoyce === "true"}'
                  class="pointer" style="padding-bottom: 20px" (click)='showAll()'>ALL</div>
                <div [ngClass]='{"bmw-active-link": isShowNew && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"),
                "mini-active-link": isShowNew && APP_SETTINGS.isMINI === "true",
                "rr-active-link": isShowNew && APP_SETTINGS.isRollsRoyce === "true"}'
                  class="pointer" style="padding-bottom: 20px" (click)='showNew()'>
                  NEW
                  <div class="badge" *ngIf="newDocsCount>0" [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>{{newDocsCount}}</div>
                </div>
                <div [ngClass]='{"bmw-active-link": isShowHistory && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true")
                , "mini-active-link": isShowHistory && APP_SETTINGS.isMINI === "true",
                "rr-active-link": isShowHistory && APP_SETTINGS.isRollsRoyce === "true"}'
                  class="pointer" style="padding-bottom: 20px" (click)='showHistory()'>HISTORY</div>
                <div [ngClass]='{"bmw-active-link": isShowSaved && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"),
                "mini-active-link": isShowSaved && APP_SETTINGS.isMINI === "true",
                "rr-active-link": isShowSaved && APP_SETTINGS.isRollsRoyce === "true"}'
                  class="pointer" style="padding-bottom: 20px" (click)='showSaved()'>SAVED</div>
              </div>
              <div class="flex-30"></div>
            </div>
            <div class="bmw-lg-sib-content">
              <div class="flex-container" style="padding:27px 20px 34px 30px">
                <div class="bmw-lg-sib-title flex-50">Parts Bulletins</div>
                <div class="flex"></div>
                <div class="flex-32">
                  <form class="input-group" name="findDocs" style="width: 100%">
                    <input type="text" class="form-control" size=15 style="height:34px;font-size:16px;border-radius:0px" placeholder="Find Bulletin"
                      name="techDoc" [(ngModel)]="search4bulletins">
                    <div class="input-group-btn">
                      <button [ngClass]="{'mini-button-style' : APP_SETTINGS.isMINI === 'true', 'bmw-button-style': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true'),
                      'rr-button-style' : APP_SETTINGS.isRollsRoyce === 'true'}" class="btn btn-default"
                        type="submit">
                        <i class="glyphicon glyphicon-search"></i>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
              <div *ngIf='isShowSaved && partsBulletins?.length > 0'>
                <div *ngFor='let doc of partsBulletins; let i=index'>
                  <a class="flex-container row" [ngClass]='{"active": expandPbs[i]}' (click)='expandPbs[i] = !expandPbs[i]' [href]='"#pbs" + i'
                    style="margin:0 30px" data-toggle="collapse">
                    <div class="flex-5">
                      <i class="material-icons">folder_special</i>
                    </div>
                    <div class="flex-90" style="font-weight: bold;line-height:1.8">
                      {{doc?.title}}
                    </div>
                    <div class="flex" style="text-align: right">
                      <i class="material-icons bmw-pbs-toggle-expand" [ngClass]='{"active": expandPbs[i]}'>expand_more</i>
                    </div>
                  </a>
                  <div [id]='"pbs" + i' class="collapse bmw-lg-save">
                    <div class="flex-container row" *ngFor='let bulletin of doc?.content' style="margin-left:4%">
                      <div class="flex-5" style="text-align:center">
                        <div *ngIf='bulletin?.savedBulletinGroup; else elseBlock'>
                          <i class="material-icons">star</i>
                        </div>
                        <ng-template #elseBlock>
                          <ng-container *ngIf='bulletin?.updatedBulletin; else elseBlock2'>
                            <i class="material-icons">new_releases</i>
                          </ng-container>
                        </ng-template>
                        <ng-template #elseBlock2>
                          <ng-container *ngIf='bulletin?.newBulletin'>
                            <i class="material-icons">fiber_new</i>
                          </ng-container>
                        </ng-template>
                      </div>
                      <div class="flex-12">{{bulletin?.bulletinDisplayNumber}}</div>
                      <div class="flex-70">{{bulletin.description}}</div>
                      <div class="flex">{{bulletin.releaseDate | date: 'yyyy-MM-dd'}}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf='!isShowSaved'>
                <div class="flex-container row" style="border-bottom:2px solid #e9e9e9;">
                  <div class="flex-5"></div>
                  <div style="display:inherit" class="flex-9">
                    <div style="font-weight:bold;font-size:12px;">Bulletin#</div>
                    <i class="fa pointer" (click)="sortByProperty('bulletinDisplayId')" style="margin-left:5px" [ngClass]="{'fa-sort': column != 'bulletinDisplayId', 'fa-sort-asc bmw-sort-control-asc': (column == 'bulletinDisplayId' && isDesc), 'fa-sort-desc': (column == 'bulletinDisplayId' && !isDesc) }"
                      aria-hidden="true"> </i>
                  </div>
                  <div class="flex-4"></div>
                  <div style="display:inherit" class="flex">
                    <div style="font-weight:bold;font-size:12px;">Title</div>
                    <i class="fa pointer" (click)="sortByProperty('description')" style="margin-left:5px" [ngClass]="{'fa-sort': column != 'description', 'fa-sort-asc bmw-sort-control-asc': (column == 'description' && isDesc), 'fa-sort-desc': (column == 'description' && !isDesc) }"
                      aria-hidden="true"> </i>
                  </div>
                  <div class="flex-6"></div>
                  <div style="display:inherit" class="flex-17">
                    <div style="font-weight:bold;font-size:12px;">Date</div>
                    <i class="fa pointer" (click)="sortByProperty('relseaseDate')" style="margin-left:5px" [ngClass]="{'fa-sort': column != 'releaseDate', 'fa-sort-asc bmw-sort-control-asc': (column == 'releaseDate' && isDesc), 'fa-sort-desc': (column == 'releaseDate' && !isDesc) }"
                      aria-hidden="true"> </i>
                  </div>
                </div>
                <a target='_blank' [href]='isShowHistory ? "mount/parts_bulletin/"+doc?.bulletinFile?.filePath : "mount/parts_bulletin/"+doc.attachments[0]?.fileName'
                  *ngFor='let doc of partsBulletins | filterResults : filter |
                  searchFilter: "bulletinDisplayId,bulletinDisplayNumber,description,releaseDate": search4bulletins | sortBy: {property: column, direction: direction}'
                  class="bmw-lg-sib flex-container row" (click)='addBulletinToHistory(isShowHistory, doc?.id, doc?.bulletinDisplayNumber)'>
                  <!-- <div *ngIf='!doc'>Hell</div> -->
                  <div class="flex-5" style="text-align:center">
                    <div *ngIf='doc?.savedBulletinGroup; else elseBlock'>
                      <i class="material-icons">star</i>
                    </div>
                    <ng-template #elseBlock>
                      <ng-container *ngIf='doc?.updatedBulletin; else elseBlock2'>
                        <i class="material-icons">new_releases</i>
                      </ng-container>
                    </ng-template>
                    <ng-template #elseBlock2>
                      <ng-container *ngIf='doc?.newBulletin'>
                        <i class="material-icons">fiber_new</i>
                      </ng-container>
                    </ng-template>
                  </div>
                  <div class="flex-9">{{doc?.bulletinDisplayId}}</div>
                  <div class="flex-4"></div>
                  <div class="flex">{{doc?.description}}</div>
                  <div class="flex-6"></div>
                  <div class="flex-17">{{doc?.releaseDate | date: 'yyyy-MM-dd'}}</div>
                </a>
              </div>
            </div>
          </div>
          <div class="flex"></div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Ipad HTML -->
<div *ngIf='screenWidth >= 767 && screenWidth <= 991'>
  <!-- <div class="visible-sm" (window:orientationchange)="screenRotate($event)"> -->

  <div (window:orientationchange)="screenRotate($event)">
    <div class="flex-container">
      <div class="flex-25"></div>
      <div class="flex-container row flex-align-center">
        <div [ngClass]='{"bmw-active-link": isShowAll && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"),
        "mini-active-link": isShowAll && APP_SETTINGS.isMINI === "true",
       "rr-active-link": isShowAll && APP_SETTINGS.isRollsRoyce === "true"}'
          class="pointer" style="padding-bottom: 20px" (click)='showAll()'>ALL</div>
        <div [ngClass]='{"bmw-active-link": isShowNew && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"),
        "mini-active-link": isShowNew && APP_SETTINGS.isMINI === "true",
        "rr-active-link": isShowNew && APP_SETTINGS.isRollsRoyce === "true"}'
          class="pointer" style="padding-bottom: 20px" (click)='showNew()'>
          NEW
          <div class="badge" *ngIf="newDocsCount>0" [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>{{newDocsCount}}</div>
        </div>
        <div [ngClass]='{"bmw-active-link": isShowHistory && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true")
        , "mini-active-link": isShowHistory && APP_SETTINGS.isMINI === "true",
        "rr-active-link": isShowHistory && APP_SETTINGS.isRollsRoyce === "true"}'
          class="pointer" style="padding-bottom: 20px" (click)='showHistory()'>HISTORY</div>
        <div [ngClass]='{"bmw-active-link": isShowSaved && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"),
        "mini-active-link": isShowSaved && APP_SETTINGS.isMINI === "true",
        "rr-active-link": isShowSaved && APP_SETTINGS.isRollsRoyce === "true"}'
          class="pointer" style="padding-bottom: 20px" (click)='showSaved()'>SAVED</div>
      </div>
      <div class="flex-25"></div>
    </div>
    <div class="bmw-sm-sib">
      <div class="flex-container" style="padding:17px 15px 0 15px;">
        <div [routerLink]='["/manage-profile", "bulletin-manager"]' class="flex-90" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>Saved Bulletin Manager</div>
        <div class="flex">
          <div data-toggle="modal" data-target="#filterModal">
            <i class="material-icons filter-icon" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>filter_list</i>
            <div class="bmw-sib-filter-label" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>Filter</div>
          </div>
        </div>
      </div>
      <div class="bmw-sm-sib-title">Parts Bulletins</div>
      <div style="margin:0 25% 7% 25%">
        <form class="input-group" name="findDocs" style="width: 100%">
          <input type="text" class="form-control" size=15 style="height:34px;font-size:16px;border-radius:0px" placeholder="Find Bulletin"
            name="techDoc" [(ngModel)]="search4bulletins">
          <div class="input-group-btn">
            <button [ngClass]="{'mini-button-style' : APP_SETTINGS.isMINI === 'true', 'bmw-button-style': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true'),
            'rr-button-style' : APP_SETTINGS.isRollsRoyce === 'true'}" class="btn btn-default"
              type="submit">
              <i class="glyphicon glyphicon-search"></i>
            </button>
          </div>
        </form>
      </div>
      <div *ngIf='isShowSaved && partsBulletins?.length > 0'>
        <div *ngFor='let doc of partsBulletins; let i=index'>
          <a class="flex-container row" [ngClass]='{"active": expandPbs[i]}' (click)='expandPbs[i] = !expandPbs[i]' [href]='"#pbs" + i'
            style="margin:0 30px" data-toggle="collapse">
            <div class="flex-5">
              <i class="material-icons">folder_special</i>
            </div>
            <div class="flex-90" style="font-weight: bold;line-height:1.8">
              {{doc?.title}}
            </div>
            <div class="flex" style="text-align: right">
              <i class="material-icons bmw-pbs-toggle-expand" [ngClass]='{"active": expandPbs[i]}'>expand_more</i>
            </div>
          </a>
          <div [id]='"pbs" + i' class="collapse bmw-lg-save">
            <div class="flex-container row" *ngFor='let bulletin of doc?.content' style="margin-left:4%">
              <div class="flex-5" style="text-align:center">
                <div *ngIf='bulletin?.savedBulletinGroup; else elseBlock'>
                  <i class="material-icons">star</i>
                </div>
                <ng-template #elseBlock>
                  <ng-container *ngIf='bulletin?.updatedBulletin; else elseBlock2'>
                    <i class="material-icons">new_releases</i>
                  </ng-container>
                </ng-template>
                <ng-template #elseBlock2>
                  <ng-container *ngIf='bulletin?.newBulletin'>
                    <i class="material-icons">fiber_new</i>
                  </ng-container>
                </ng-template>
              </div>
              <div class="flex-12">{{bulletin?.bulletinDisplayNumber}}</div>
              <div class="flex-65">{{bulletin.description}}</div>
              <div class="flex">{{bulletin.releaseDate | date: 'yyyy-MM-dd'}}</div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf='!isShowSaved'>
        <div class="flex-container row" style="border-bottom:2px solid #e9e9e9;">
          <div class="flex-5"></div>
          <div style="display:inherit" class="flex-8">
            <div style="font-weight:bold;font-size:12px;">Bulletin#</div>
            <i class="fa pointer" (click)="sortByProperty('bulletinDisplayId')" style="margin-left:5px" [ngClass]="{'fa-sort': column != 'bulletinDisplayId', 'fa-sort-asc bmw-sort-control-asc': (column == 'bulletinDisplayId' && isDesc), 'fa-sort-desc': (column == 'bulletinDisplayId' && !isDesc) }"
              aria-hidden="true"> </i>
          </div>
          <div class="flex-4"></div>
          <div style="display:inherit" class="flex">
            <div style="font-weight:bold;font-size:12px;">Title</div>
            <i class="fa pointer" (click)="sortByProperty('description')" style="margin-left:5px" [ngClass]="{'fa-sort': column != 'description', 'fa-sort-asc bmw-sort-control-asc': (column == 'description' && isDesc), 'fa-sort-desc': (column == 'description' && !isDesc) }"
              aria-hidden="true"> </i>
          </div>
          <div class="flex-7"></div>
          <div style="display:inherit" class="flex-17">
            <div style="font-weight:bold;font-size:12px;">Date</div>
            <i class="fa pointer" (click)="sortByProperty('releaseDate')" style="margin-left:5px" [ngClass]="{'fa-sort': column != 'releaseDate', 'fa-sort-asc bmw-sort-control-asc': (column == 'releaseDate' && isDesc), 'fa-sort-desc': (column == 'releaseDate' && !isDesc) }"
              aria-hidden="true"> </i>
          </div>
        </div>
        <a target='_blank' [href]='isShowHistory ? "mount/parts_bulletin/"+doc?.bulletinFile?.filePath : "parts_bulletin/"+doc.attachments[0]?.fileName'
          *ngFor='let doc of partsBulletins | filterResults : filter |
          searchFilter: "bulletinDisplayId,bulletinDisplayNumber,description,releaseDate": search4bulletins | sortBy: {property: column, direction: direction}'
          flex class="bmw-lg-sib flex-container row" (click)='addBulletinToHistory(isShowHistory, doc?.id, doc?.bulletinDisplayNumber)'>

          <!-- <div *ngIf='!doc'>Hell</div> -->
          <div class="flex-5" style="text-align:center">
            <div *ngIf='doc?.savedBulletinGroup; else elseBlock'>
              <i class="material-icons">star</i>
            </div>
            <ng-template #elseBlock>
              <ng-container *ngIf='doc?.updatedBulletin; else elseBlock2'>
                <i class="material-icons">new_releases</i>
              </ng-container>
            </ng-template>
            <ng-template #elseBlock2>
              <ng-container *ngIf='doc?.newBulletin'>
                <i class="material-icons">fiber_new</i>
              </ng-container>
            </ng-template>
          </div>
          <div class="flex-8">{{doc?.bulletinDisplayId}}</div>
          <div class="flex-4"></div>
          <div class="flex">{{doc?.description}}</div>
          <div class="flex-7"></div>
          <div class="flex-17">{{doc?.releaseDate | date: 'yyyy-MM-dd'}}</div>
        </a>
      </div>
    </div>
    <!-- Modal -->
    <div class="modal fade bmw-sm-modal-dialog" id="filterModal" role="dialog">
      <div class="modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" style="color:white">&times;</button>
            <h4 class="modal-title">Filter</h4>
          </div>
          <div class="modal-body">
            <div class="row bmw-no-gutter">
              <div class="row bmw-no-gutter">Main Group</div>
              <div class="row bmw-no-gutter">
                <select [(ngModel)]='inputMainGroup'>
                  <option [ngValue]="undefined" disabled selected> Select Main Group </option>
                  <option *ngFor='let group of mainGroupList' [ngValue]='group'>{{group}}</option>
                </select>
              </div>
            </div>
            <div class="row bmw-no-gutter" style="margin-top:15px">
              <div class="row bmw-no-gutter">Year Published</div>
              <div class="row bmw-no-gutter">
                <div class="row bmw-no-gutter">
                  <div class="col-xs-4 bmw-no-gutter bmw-xs-results-filter-year-label">
                    From
                  </div>
                  <div class="col-xs-7 bmw-no-gutter bmw-width-30-percent bmw-filter-select">
                    <select class="form-control" id="toYear" [(ngModel)]='inputToYear'>
                      <option *ngFor="let year of toYears" [ngValue]="year">{{year}}</option>
                    </select>
                  </div>

                </div>
                <div class="row bmw-no-gutter" style="margin-top:10px">
                  <div class="col-xs-4 bmw-no-gutter bmw-xs-results-filter-year-label">
                    To
                  </div>
                  <div class="col-xs-7 bmw-no-gutter bmw-width-30-percent bmw-filter-select">
                    <select class="form-control" id="toYear" [(ngModel)]='inputToYear'>
                      <option *ngFor="let year of toYears" [ngValue]="year">{{year}}</option>
                    </select>
                  </div>

                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer" style="border: 0px solid white;">
            <div class="row bmw-no-gutter">
              <div class="col-xs-6" style="padding-right:10%">
                <div class="bmw-button-secondary" style="border:2px solid #fff" (click)='clearFilter()'>Clear Filter</div>
              </div>
              <div class="col-xs-6" style="padding-right:10%">
                <div data-dismiss="modal" [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-button-primary"
                  (click)='applyFilter()'>Apply Filter</div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
<!-- Mobile HTML -->
<div *ngIf='screenWidth > 319 && screenWidth < 767'>
  <!-- <div class="visible-xs" (window:orientationchange)="screenRotate($event)"> -->

  <div (window:orientationchange)="screenRotate($event)">
    <div class="flex-container">
      <div class="flex-container row flex-align-center">
        <div [ngClass]='{"bmw-active-link": isShowAll && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"),
        "mini-active-link": isShowAll && APP_SETTINGS.isMINI === "true",
       "rr-active-link": isShowAll && APP_SETTINGS.isRollsRoyce === "true"}'
          class="pointer" style="padding-bottom: 20px" (click)='showAll()'>ALL</div>
        <div [ngClass]='{"bmw-active-link": isShowNew && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"),
        "mini-active-link": isShowNew && APP_SETTINGS.isMINI === "true",
        "rr-active-link": isShowNew && APP_SETTINGS.isRollsRoyce === "true"}'
          class="pointer" style="padding-bottom: 20px" (click)='showNew()'>
          NEW
          <div class="badge" *ngIf="newDocsCount>0" [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>{{newDocsCount}}</div>
        </div>
        <div [ngClass]='{"bmw-active-link": isShowHistory && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true")
        , "mini-active-link": isShowHistory && APP_SETTINGS.isMINI === "true",
        "rr-active-link": isShowHistory && APP_SETTINGS.isRollsRoyce === "true"}'
          class="pointer" style="padding-bottom: 20px" (click)='showHistory()'>HISTORY</div>
        <div [ngClass]='{"bmw-active-link": isShowSaved && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"),
        "mini-active-link": isShowSaved && APP_SETTINGS.isMINI === "true",
        "rr-active-link": isShowSaved && APP_SETTINGS.isRollsRoyce === "true"}'
          class="pointer" style="padding-bottom: 20px" (click)='showSaved()'>SAVED</div>
      </div>
    </div>
    <div class="bmw-xs-sib">
      <div class="flex-container" style="padding:17px 15px 0 15px;">
        <div [routerLink]='["/manage-profile", "bulletin-manager"]' class="flex" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>Saved Bulletin Manager</div>
        <div class="flex-20">
          <div data-toggle="modal" data-target="#filterModal1">
            <i class="material-icons filter-icon" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>filter_list</i>
            <div class="bmw-sib-filter-label" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>Filter</div>
          </div>
        </div>
      </div>
      <div class="bmw-xs-sib-title">Parts Bulletins</div>
      <div style="width:90%;margin-left:5%;margin-bottom:28px">
        <form class="input-group" name="findDocs" style="width: 100%">
          <input type="text" class="form-control" size=15 style="height:34px;font-size:16px;border-radius:0px" placeholder="Find Bulletin"
            name="techDoc" [(ngModel)]="search4bulletins">
          <div class="input-group-btn">
            <button [ngClass]="{'mini-button-style' : APP_SETTINGS.isMINI === 'true', 'bmw-button-style': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true'),
            'rr-button-style' : APP_SETTINGS.isRollsRoyce === 'true'}" class="btn btn-default"
              type="submit">
              <i class="glyphicon glyphicon-search"></i>
            </button>
          </div>
        </form>
      </div>
      <div *ngIf='isShowSaved && partsBulletins?.length > 0'>
        <div *ngFor='let doc of partsBulletins; let i=index'>
          <a class="flex-container row" [ngClass]='{"active": expandPbs[i]}' (click)='expandPbs[i] = !expandPbs[i]' [href]='"#pbs" + i'
            style="margin:0 15px" data-toggle="collapse">
            <div class="flex-10">
              <i class="material-icons">folder_special</i>
            </div>
            <div class="flex-90" style="font-weight: bold;line-height:1.8">
              {{doc?.title}}
            </div>
            <div class="flex" style="text-align: right">
              <i class="material-icons bmw-pbs-toggle-expand" [ngClass]='{"active": expandPbs[i]}'>expand_more</i>
            </div>
          </a>
          <div [id]='"pbs" + i' class="collapse bmw-xs-sib-doc">
            <div class="flex-container row" *ngFor='let bulletin of doc?.content'>
              <div class="flex-container row">
                <div class="flex-8" style="text-align:center">
                  <div *ngIf='bulletin?.savedBulletinGroup; else elseBlock'>
                    <i class="material-icons">star</i>
                  </div>
                  <ng-template #elseBlock>
                    <ng-container *ngIf='bulletin?.updatedBulletin; else elseBlock2'>
                      <i class="material-icons">new_releases</i>
                    </ng-container>
                  </ng-template>
                  <ng-template #elseBlock2>
                    <ng-container *ngIf='bulletin?.newBulletin'>
                      <i class="material-icons">fiber_new</i>
                    </ng-container>
                  </ng-template>
                </div>
                <div class="flex-58">{{bulletin?.bulletinDisplayId}}</div>
                <div class="flex">{{bulletin?.releaseDate | date: 'yyyy-MM-dd'}}</div>
              </div>
              <div style="margin-left:8%;padding-bottom: 5px;">
                {{bulletin?.description}}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf='!isShowSaved'>
        <div>
          <a target="_blank" [href]='isShowHistory ? "mount/parts_bulletin/"+doc?.bulletinFile?.filePath : "mount/parts_bulletin/"+doc.attachments[0]?.fileName'
            *ngFor='let doc of partsBulletins | filterResults : filter |
        searchFilter: "bulletinDisplayId,bulletinDisplayNumber,description,releaseDate": search4bulletins | sortBy: {property: column, direction: direction}'
            class="bmw-xs-sib-doc" (click)='addBulletinToHistory(isShowHistory, doc?.id, doc?.bulletinDisplayNumber)'>
            <div class="flex-container row">
              <div class="flex-8">
                <div *ngIf='doc?.savedBulletinGroup; else elseBlock'>
                  <i class="material-icons">star</i>
                </div>
                <ng-template #elseBlock>
                  <ng-container *ngIf='doc?.updatedBulletin; else elseBlock2'>
                    <i class="material-icons">new_releases</i>
                  </ng-container>
                </ng-template>
                <ng-template #elseBlock2>
                  <ng-container *ngIf='doc?.newBulletin'>
                    <i class="material-icons">fiber_new</i>
                  </ng-container>
                </ng-template>
              </div>
              <div class="flex-58">{{doc?.bulletinDisplayId}}</div>
              <div class="flex">{{doc?.releaseDate | date: 'yyyy-MM-dd'}}</div>
            </div>
            <div style="margin-left:8%;padding-bottom: 5px;">
              {{doc?.description}}
            </div>
          </a>
        </div>
      </div>
    </div>
    <!-- Modal -->
    <div class="modal fade" id="filterModal1" role="dialog">
      <div class="modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" style="color:white">&times;</button>
            <h4 class="modal-title">Filter</h4>
          </div>
          <div class="modal-body">
            <div class="row bmw-no-gutter">
              <div class="row bmw-no-gutter">Sort by</div>
              <div class="row bmw-no-gutter">
                <select [(ngModel)]='inputSortBy' class="bmw-lg-results-select-sortby">
                  <option [ngValue]="undefined" disabled selected> Sort By </option>
                  <option *ngFor='let sort of sortBy' [ngValue]='sort.key'>{{sort.value}}</option>
                </select>
              </div>
            </div>
            <div class="row bmw-no-gutter">
              <div class="row bmw-no-gutter">Main Group</div>
              <div class="row bmw-no-gutter">
                <select [(ngModel)]='inputMainGroup'>
                  <option [ngValue]="undefined" disabled selected> Select Main Group </option>
                  <option *ngFor='let group of mainGroupList' [ngValue]='group'>{{group}}</option>
                </select>
              </div>
            </div>
            <div class="row bmw-no-gutter" style="margin-top:15px">
              <div class="row bmw-no-gutter">Year Published</div>
              <div class="row bmw-no-gutter">
                <div class="row bmw-no-gutter">
                  <div class="col-xs-4 bmw-no-gutter bmw-xs-results-filter-year-label">
                    From
                  </div>
                  <div class="col-xs-7 bmw-no-gutter bmw-width-30-percent bmw-filter-select">
                    <select class="form-control" id="toYear" [(ngModel)]='inputFromYear'>
                      <option *ngFor="let year of toYears" [ngValue]="year">{{year}}</option>
                    </select>
                  </div>

                </div>
                <div class="row bmw-no-gutter" style="margin-top:10px">
                  <div class="col-xs-4 bmw-no-gutter bmw-xs-results-filter-year-label">
                    To
                  </div>
                  <div class="col-xs-7 bmw-no-gutter bmw-width-30-percent bmw-filter-select">
                    <select class="form-control" id="toYear" [(ngModel)]='inputToYear'>
                      <option *ngFor="let year of toYears" [ngValue]="year">{{year}}</option>
                    </select>
                  </div>

                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer" style="border: 0px solid white;">
            <div class="row bmw-no-gutter">
              <div class="col-xs-6" style="padding-right:10%">
                <div class="bmw-button-secondary" style="border:2px solid #fff" (click)='clearFilter()'>Clear Filter</div>
              </div>
              <div class="col-xs-6" style="padding-right:10%">
                <div data-dismiss="modal" [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-button-primary"
                  (click)='applyFilter()'>Apply Filter</div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>